/* eslint-disable linebreak-style */
// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from '@chakra-ui/react'
import { HOME } from '../../Routes/Routes'
import HomePage from '../HomePage/HomePage'

const GooglePage = (): JSX.Element => {
  const [googleCode, setGoogleCode] = useState<string>('')
  const { pathname } = useLocation()
  const [loading, setLoading] = useState(false)
  const [googleUserInfo, setGoogleUserInfo] = useState<any>('')

  const navigate = useNavigate()

  const urlParams = new URLSearchParams(useLocation().search)
  const code: any = urlParams.get('code')

  useEffect(() => {
    if (pathname === '/callback') {
      void handleAccessToken()
    }
  }, [code, googleCode, googleUserInfo, pathname, navigate])

  const handleAccessToken = async (): Promise<void> => {
    try {
      setGoogleCode(code)
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_OAUTH}/api/v2/auth/google_auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: googleCode,
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to obtain access token')
      }

      const data = await response.json()
      setLoading(true)
      setGoogleUserInfo(data)

      localStorage.setItem('token', data?.access_token)
      localStorage.setItem('id_token', data?.id_token)
      localStorage.setItem('name', `${String(data?.given_name)} ${String(data?.family_name)}`)
      localStorage.setItem('email', data?.email)
      localStorage.setItem('picture', data?.picture)
      localStorage.setItem('oauth_provider', 'google')

      const oauthToken = localStorage.getItem('token')
      const oauthPicture = localStorage.getItem('picture') ?? ''
      const oauthEmail = localStorage.getItem('email') ?? ''
      const oauthName = localStorage.getItem('name') ?? ''
      const oauthIDToken = localStorage.getItem('id_token')
      const oauthProvider = localStorage.getItem('oauth_provider')

      if (oauthToken !== undefined && oauthIDToken !== undefined && oauthPicture !== undefined && oauthEmail !== undefined && oauthName !== undefined && oauthIDToken !== undefined && oauthProvider !== undefined) {
        navigate(HOME)
      }
    } catch (error: any) {
      console.error(error.message)
    }
  }

  if (!loading) {
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}>
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
        </div>
      </>
    )
  } else {
    return <HomePage />
  }
}

export default GooglePage
